/**
 * @generated SignedSource<<b55acbd75c1eada1e9c37b32eed7e02d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespMainContent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespAppliedFilters_user" | "SbRespQuickFilters_user" | "SbRespRefineMenuDrawer_user" | "SbRespRefineMenuSelector_user" | "SbRespSearchResultContainer_user" | "SbRespSortItems_user" | "SharedFollowTopButton_user">;
  readonly " $fragmentType": "SbRespMainContent_user";
};
export type SbRespMainContent_user$key = {
  readonly " $data"?: SbRespMainContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespMainContent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespMainContent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowTopButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawer_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespQuickFilters_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6417107ed7f9daf5d9d20c4fdd4eebf8";

export default node;
